export const EXPORT_PDF_CONFIG = {
  HEADERS_ROW_HEIGHT: 21,
  OUTSIDE_CELL_PADDING: 0,
  INSIDE_CELL_PADDING: 2,
  CELL_LINE_HEIGHT: 12,
  PAGE_VERTICAL_MARGIN: 30,
};
